import type { JSX } from 'react'
import type { MessageStatus } from './types.js'

export interface MessageStatusIndicatorProps {
  status: MessageStatus
}

interface StatusMeta {
  glyph: string
  label: string
  className: string
}

const STATUS_META: Record<MessageStatus, StatusMeta> = {
  sending: { glyph: '○', label: 'Sending', className: 'text-gray-400' },
  sent: { glyph: '✓', label: 'Sent', className: 'text-gray-400' },
  delivered: { glyph: '✓✓', label: 'Delivered', className: 'text-gray-400' },
  read: { glyph: '✓✓', label: 'Read', className: 'text-blue-500' },
  failed: { glyph: '⚠', label: 'Failed to send', className: 'text-red-600' },
  pending_approval: {
    glyph: '⧗',
    label: 'Pending approval',
    className: 'text-amber-600',
  },
  cancelled: { glyph: '⊘', label: 'Cancelled', className: 'text-gray-400' },
  received: { glyph: '↓', label: 'Received', className: 'text-gray-400' },
  queued: { glyph: '○', label: 'Queued', className: 'text-gray-400' },
  bounced: { glyph: '⚠', label: 'Bounced', className: 'text-red-600' },
}

/** Pure presentation of an outbound message's delivery state (Task 9). */
export default function MessageStatusIndicator(
  props: MessageStatusIndicatorProps,
): JSX.Element {
  const meta = STATUS_META[props.status]
  return (
    <span
      data-testid="status-indicator"
      aria-label={meta.label}
      title={meta.label}
      className={meta.className}
    >
      {meta.glyph}
    </span>
  )
}
